"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactGa = require("react-ga");

var _reactGa2 = _interopRequireDefault(_reactGa);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _validation = require("../../validation");

var _Input = require("../Input");

var _formStep = require("../../container/steps/formStep");

var _formStep2 = _interopRequireDefault(_formStep);

var _locale = require("../../locale");

var _locale2 = _interopRequireDefault(_locale);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var CarDataSelection = function (_React$Component) {
  _inherits(CarDataSelection, _React$Component);

  function CarDataSelection(props) {
    _classCallCheck(this, CarDataSelection);

    var _this = _possibleConstructorReturn(this, (CarDataSelection.__proto__ || Object.getPrototypeOf(CarDataSelection)).call(this, props));

    _this.state = {
      valid: false,
      mileage: props.mileage,
      registerDate: props.registerDate,
      licensePlate: props.licensePlate,
      fin: props.fin
    };
    _this.fields = [];
    _this.handleInputChange = _this.handleInputChange.bind(_this);
    _this.validateForm = _this.validateForm.bind(_this);
    return _this;
  }

  _createClass(CarDataSelection, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      this.validateForm();
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.loadBrands();
      this.validateForm();

      _reactGa2.default.event({
        category: "OTB",
        action: "Step",
        label: "Vehicle"
      });
    }
  }, {
    key: "getFormData",
    value: function getFormData() {
      var _props = this.props,
          brandId = _props.brandId,
          modelId = _props.modelId,
          typeId = _props.typeId;
      var _state = this.state,
          mileage = _state.mileage,
          registerDate = _state.registerDate,
          licensePlate = _state.licensePlate,
          fin = _state.fin;
      return {
        stepId: "vehicle",
        formData: {
          brandId: brandId,
          modelId: modelId,
          typeId: typeId,
          mileage: mileage,
          registerDate: registerDate,
          licensePlate: licensePlate,
          fin: fin
        }
      };
    }
  }, {
    key: "validateForm",
    value: function validateForm() {
      var wasValid = this.state.valid;
      var valid = this.props.typeId > 0 && this.fields[0].state.valid;

      if (wasValid !== valid) {
        this.setState({
          valid: valid
        });

        if (valid) {
          this.props.enableSubmit();
        } else {
          this.props.disableSubmit();
        }
      }
    }
  }, {
    key: "handleInputChange",
    value: function handleInputChange(event) {
      var target = event.target;
      var value = target.type === 'checkbox' ? target.checked : target.value;
      var name = target.name;
      this.setState(_defineProperty({}, name, value), this.validateForm);
    }
  }, {
    key: "renderBrandSelect",
    value: function renderBrandSelect() {
      var _this2 = this;

      var options = [];

      for (var brandId in this.props.availableBrands) {
        var brand = this.props.availableBrands[brandId];
        options.push(_react2.default.createElement("option", {
          key: "b_" + brandId,
          value: brand.Id
        }, brand.Value));
      }

      return _react2.default.createElement("select", {
        onChange: function onChange(event) {
          return _this2.props.selectBrand(parseInt(event.target.value));
        },
        value: this.props.brandId || 0,
        name: "brandId"
      }, _react2.default.createElement("option", {
        value: "0"
      }, _locale2.default.getResource("mainFilter_SelectBrand") + " *"), options);
    }
  }, {
    key: "renderModelSelect",
    value: function renderModelSelect() {
      var _this3 = this;

      var options = [];

      for (var modelId in this.props.availableModels) {
        var model = this.props.availableModels[modelId];
        options.push(_react2.default.createElement("option", {
          key: "m_" + modelId,
          value: model.Id
        }, model.Value));
      }

      return _react2.default.createElement("select", {
        disabled: !this.props.brandId || Object.keys(this.props.availableModels).length === 1,
        name: "modelId",
        onChange: function onChange(event) {
          return _this3.props.selectModel(parseInt(event.target.value));
        },
        value: this.props.modelId || 0
      }, _react2.default.createElement("option", {
        value: "0"
      }, _locale2.default.getResource("mainFilter_SelectModel") + " *"), options);
    }
  }, {
    key: "renderTypeSelect",
    value: function renderTypeSelect() {
      var _this4 = this;

      var options = [];

      for (var typeId in this.props.availableTypes) {
        var type = this.props.availableTypes[typeId];
        options.push(_react2.default.createElement("option", {
          key: "t_" + typeId,
          value: type.Id
        }, type.Value));
      }

      return _react2.default.createElement("select", {
        disabled: !this.props.modelId || Object.keys(this.props.availableTypes).length === 1,
        name: "typeId",
        onChange: function onChange(event) {
          return _this4.props.selectType(parseInt(event.target.value));
        },
        value: this.props.typeId || 0
      }, _react2.default.createElement("option", {
        value: "0"
      }, _locale2.default.getResource("mainFilter_SelectType") + " *"), options);
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      return _react2.default.createElement("div", null, _react2.default.createElement("div", {
        className: "sub"
      }, "Auswahl Fahrzeug/Daten"), _react2.default.createElement("div", {
        className: "group"
      }, _react2.default.createElement("div", {
        className: "line"
      }, this.renderBrandSelect(), this.renderModelSelect(), this.renderTypeSelect())), _react2.default.createElement("div", {
        className: "group"
      }, _react2.default.createElement("div", {
        className: "line"
      }, _react2.default.createElement("div", {
        className: "input-group"
      }, _react2.default.createElement("input", {
        type: "number",
        defaultValue: this.state.registered,
        name: "registerDate",
        onChange: this.handleInputChange,
        placeholder: _locale2.default.getResource("appointmentForm_step1_RegistrationDate"),
        min: "1900",
        max: new Date().getFullYear()
      })), _react2.default.createElement("div", {
        className: "input-group"
      }, _react2.default.createElement("input", {
        type: "text",
        id: "slrhp_i-2",
        name: "mileage",
        onChange: this.handleInputChange,
        placeholder: _locale2.default.getResource("appointmentForm_step1_Mileage"),
        defaultValue: this.state.mileage
      })), _react2.default.createElement("div", {
        className: "input-group"
      }, _react2.default.createElement(_Input.ValidatedInput, {
        ref: function ref(_ref) {
          return _this5.fields.push(_ref);
        },
        value: this.state.licensePlate,
        placeholder: _locale2.default.getResource("appointmentForm_step1_LicenceTag"),
        onChange: this.handleInputChange,
        name: "licensePlate",
        validations: [_validation.required]
      })), _react2.default.createElement("div", {
        className: "input-group"
      }, _react2.default.createElement("input", {
        type: "text",
        id: "slrhp_i-4",
        name: "fin",
        onChange: this.handleInputChange,
        placeholder: "Fahrzeug-Identnummer (FIN)",
        defaultValue: this.state.fin
      })))));
    }
  }]);

  return CarDataSelection;
}(_react2.default.Component);

CarDataSelection.propTypes = {
  loadBrands: _propTypes2.default.func.isRequired,
  availableBrands: _propTypes2.default.object.isRequired,
  availableModels: _propTypes2.default.object.isRequired,
  availableTypes: _propTypes2.default.object.isRequired,
  brandId: _propTypes2.default.number,
  modelId: _propTypes2.default.number,
  typeId: _propTypes2.default.number,
  selectBrand: _propTypes2.default.func.isRequired,
  selectModel: _propTypes2.default.func.isRequired,
  selectType: _propTypes2.default.func.isRequired,
  mileage: _propTypes2.default.string.isRequired,
  registerDate: _propTypes2.default.string.isRequired,
  licensePlate: _propTypes2.default.string.isRequired,
  fin: _propTypes2.default.string.isRequired
};
exports.default = (0, _formStep2.default)(CarDataSelection);